export default "__VITE_ASSET__D4fz1tqU__"